import objectHash from "object-hash";

export function getObjectHash(object: [] | {}) {
  try {
    return objectHash(object);
  } catch (error) {
    return null;
  }
}
